import { Card, Layout, Menu, Button, Row, Col, ConfigProvider, Input, message } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import './css/cramSchool.css';
import axios from 'axios';
import WYSIWYGModal from './components/WYSIWYGModal';
import { CloseOutlined, MessageOutlined, EditOutlined, MenuOutlined } from '@ant-design/icons';
import { Mini_chatRoom } from './ChatRoom';
import Label_language from '../language';
const { Header, Footer, Sider, Content } = Layout;
const label_language = Label_language.cramschool.children
const InputOutline = styled.div`
    .ant-input-status-error{
        border-top-style: hidden;
        border-right-style: hidden;
        border-left-style: hidden;
        border-bottom-style: groove;
        border-radius:0px;
        background-color:#f5f5f5;
        border-width:5px;
    }
`;
const MainOutlet = () => {
    // label_language.News.children.add_news[language]
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const navigate = useNavigate();
    const location = useLocation();
    const [menu_sider, setMenuSider] = useState([]);
    const [back, setBack] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [content, setContent] = useState('');
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [permission, setPermission] = useState(false);
    const [selecte_keys, setSelectedKeys] = useState(window.location.pathname);
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const titles = {
        '/cramSchool': label_language.Route.children.home[language],
        '/cramSchool/News': label_language.Route.children.news[language],
        '/cramSchool/ClassIntroduce': label_language.Route.children.class_introduce[language],
        '/cramSchool/Class': label_language.Route.children.class[language],
        '/cramSchool/Environment': label_language.Route.children.environment[language],
        '/cramSchool/ShareLearning': label_language.Route.children.sharelearning[language],
        '/cramSchool/VideoWatch': label_language.Route.children.videowatch[language],
        '/cramSchool/Teachers': label_language.Route.children.teachers[language],
        '/cramSchool/AboutMercy': label_language.Route.children.aboutMercy[language],
        '/cramSchool/Appointment': label_language.Route.children.appointment[language],
        // '/cramSchool/Enroll': label_language.Route.children.enroll[language],
        '/cramSchool/NewCourse': label_language.Route.children.newcourse[language],
        // '/cramSchool/StudentEnroll': '學生資料填寫'
    }
    const item = [
        {
            key: '/cramSchool',
            label: label_language.Button.children.home[language],
        },
        {
            key: "/cramSchool/News",
            label: label_language.Button.children.news[language],
        },
        {
            key: "/cramSchool/ClassIntroduce",
            label: label_language.Button.children.class_introduce[language],
        },
        {
            key: "/cramSchool/Class",
            label: label_language.Button.children.class[language],
        },
        {
            key: "/cramSchool/Environment",
            label: label_language.Button.children.environment[language],
        },
        {
            key: "/cramSchool/ShareLearning",
            label: label_language.Button.children.sharelearning[language],
        },
        {
            key: "/cramSchool/VideoWatch",
            label: label_language.Button.children.videowatch[language],
        },
        {
            key: "/cramSchool/Teachers",
            label: label_language.Button.children.teachers[language],
        },
        {
            key: "/cramSchool/AboutMercy",
            label: label_language.Button.children.aboutMercy[language],
        },
        {
            key: '/cramSchool/NewCourse',
            label: label_language.Button.children.newcourse[language],

        },
        {
            key: "/cramSchool/Appointment",
            label: label_language.Button.children.appointment[language],
        },
        // {
        //     key: "/cramSchool/Enroll",
        //     label: label_language.Button.children.enroll[language],
        // },

        // {
        //     key: "/cramSchool/StudentEnroll",
        //     label: `學生資料填寫`,
        // },
    ]
    const onSelect = (e) => {
        navigate(e.key)
        document.title = titles[e.key]
        setSelectedKeys([e.key])
        setCollapsed(false);
    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/contact_us', { params: { "blog_type_id": 10, "blog_id": 116 } })
            .then((response) => {
                setContent(response.data.data[0]);
            })
    }
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        };
        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    useEffect(() => {
        get_header();
    }, [])
    const visit_log = () => {
        axios
            .post('/cramSchool/api/visit_statistics', {
                url: window.location.pathname
            })
    }
    const get_identity = () => {
        axios
            .get('/permission_management/permission_manage_self')
            .then(response => {
                let data = response.data?.data
                console.log({data})

                let firstData = data.find((ele)=>true)
                let rolePermission = firstData?.role_permission || []
                if (rolePermission.length !== 0) {
                    setBack(true);
                    setPermission(true);
                }
            })
    }

    useEffect(() => {
        setSelectedKeys([window.location.pathname])
        document.title = titles[window.location.pathname]
        get_identity();
        visit_log()
        // if (window.location.pathname.split('/').length == 4) {
        let source = window.location.pathname.split('/')[2];
        if (source == 'ClassIntroduce') {
            document.title = label_language.Route.children.class_introduce[language];
        } else if (source == 'News') {
            document.title = label_language.Route.children.news[language];
        } else if (source == 'ShareLearning') {
            document.title = label_language.Route.children.sharelearning[language];
        } else if (source == 'Class') {
            document.title = label_language.Route.children.class[language];
        } else {
            document.title = '學生資料填寫'
        }
        // }
    }, [window.location.pathname])
    const handleUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/contact_us`, [{
                // "title": '聯繫我們',
                // "content": content,
                ...content,
                "blog_type_id": 10,
                "annoucement_time": time,
                // "blog_id": 116

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_open_wyswyg(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    set_open_wyswyg(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header();
                // set_open_wyswyg(false);
            })
    }
    return (
        <>
            {contextHolder}
            <WYSIWYGModal
                open={open_wyswyg}
                setOpen={set_open_wyswyg}
                data={content?.content}
                setData={setContent}
                handleUpdate={handleUpdate}
            />
            <Layout className="layout" >
                <Header style={{ backgroundColor: '#ffffff' }}>
                    {dimensions['width'] > 1450 ? <>
                        <Row justify={'space-between'}>
                            <Col className='example' md={{ span: 2 }} onClick={e => { navigate('/cramSchool'); document.title = label_language.home[language]; setSelectedKeys(['/cramSchool']) }} style={{ cursor: 'pointer' }}>
                                <img width="auto" height='64px' src='/cram_school/logo.png'></img>
                            </Col>
                            <Col span={22}>
                                <Menu
                                    theme="light"
                                    mode="horizontal"
                                    defaultSelectedKeys={['/cramSchool']}
                                    selectedKeys={selecte_keys}
                                    onSelect={onSelect}
                                    right
                                    disabledOverflow
                                    items={item}
                                />
                            </Col>
                        </Row>
                    </> :
                        <>
                            <Row justify={'space-between'}>
                                <Col className='example' style={{ cursor: 'pointer' }} onClick={e => navigate('/cramSchool')}>
                                    <img width="auto" height='64px' src='/cram_school/logo.png'></img>
                                </Col>
                                <Col >
                                    <MenuOutlined
                                        onClick={e => { setCollapsed(!collapsed) }}
                                        style={{
                                            marginBottom: 16,
                                            cursor: 'pointer'
                                        }} />
                                </Col>
                            </Row>
                        </>}
                </Header>
                <Content
                    style={{
                        padding: '30px 50px',
                        fontSize: "18px",
                        background: '#f5f5f5'
                        // background: '#FFFFFF'
                    }}
                >
                    {/* {dimensions['width'] <= 1200 ?
                        <> */}
                    {collapsed && (<Menu
                        mode="inline"
                        defaultSelectedKeys={['/']}
                        selectedKeys={selecte_keys}
                        onClick={onSelect}
                        items={item}
                        style={{
                            whiteSpace: 'nowrap',
                            width: '100%',
                            textAlign: 'center'
                        }}
                    />)}
                    {/* </> : null} */}
                    <Row gutter={[0, 8]}>
                        {back ? <>
                            <Col span={24}>
                                <Row justify={'end'}>
                                    <Col>
                                        <Button type='primary' className='example' onClick={e => navigate('/cramSchool/admin')}>{label_language.Common.children.back[language]}</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </> : null}
                        <Col span={24}>
                            <Outlet />
                        </Col>
                    </Row>
                </Content>
                <Footer
                    style={{
                        textAlign: 'center',
                    }}
                >
                    <Mini_chatRoom />
                    <InputOutline>
                        <Row gutter={[16, 8]} justify="center" align="bottom">
                            <Col span={24} style={{ borderTop: 'solid #ACC0D8 1px ' }}> </Col>
                            <Col span={24} style={{ borderTop: 'solid #505050 3px ' }}> </Col>
                            <Col span={24} style={{ borderTop: 'solid #ACC0D8 1px ' }}> </Col>
                            <Col sm={{ span: 24 }} md={{ span: 10 }} style={{ position: 'relative' }}>
                                <Row gutter={[0, 4]}>
                                    <Col>
                                        <span dangerouslySetInnerHTML={{ __html: content.content }}></span>
                                    </Col>
                                    {permission ? <>
                                        <Col style={{ position: 'absolute', left: '85%', top: '0%' }}>
                                            <EditOutlined
                                                className='example'
                                                style={{
                                                    backgroundColor: '#F9D4E5',
                                                    fontSize: '1.2rem',
                                                    borderRadius: '50%',
                                                    padding: '8px',
                                                    zIndex: 99
                                                }}
                                                onClick={e => set_open_wyswyg(true)}
                                            />
                                        </Col>
                                    </> : null}
                                    {/* <Col span={24} style={{ fontSize: '23px', textAlign: 'left' }}>Mercy補習班</Col>
                                    <Col span={24} style={{ fontSize: '15px', textAlign: 'left' }}>6439-143</Col>
                                    <Col span={24} style={{ fontSize: '15px', textAlign: 'left' }}>6412-374</Col>
                                    <Col span={24} style={{ fontSize: '15px', textAlign: 'left' }}>mercyenglishcenter1024@gmail.com</Col>
                                    <Col span={24} style={{ fontSize: '15px', textAlign: 'left' }}>仁愛路131號</Col> */}
                                    <Col span={24}></Col>
                                    <Col span={24} style={{ fontSize: '15px', textAlign: 'left' }}>{label_language.Button.children.copyright[language]}</Col>
                                </Row>
                            </Col>
                            <Col sm={{ span: 24 }} md={{ span: 10 }}>
                                <Row justify={'end'} gutter={4}>
                                    <Col>
                                        <img alt="Facebook" onClick={e => window.open('https://www.facebook.com/MERCYEnglishCenter')} style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }} fetchpriority="high" src="/cram_school/facebook.png"></img>
                                    </Col>
                                    <Col>
                                        <img alt="line" onClick={e => window.open('https://liff.line.me/1645278921-kWRPP32q/?accountId=zik4112a')} style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }} fetchpriority="high" src="/cram_school/line.png"></img>
                                    </Col>
                                    <Col>
                                        <img alt="Instagram" onClick={e => window.open('https://instagram.com/mercy_english_center?igshid=YmMyMTA2M2Y=')} style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }} fetchpriority="high" src="/cram_school/instagram.png"></img>
                                    </Col>
                                    <Col>
                                        <img alt="YouTube " onClick={e => window.open('https://www.youtube.com/@mercyenglishcenter3223')} style={{ width: '40px', height: ' 40px', objectFit: 'cover', cursor: 'pointer' }} fetchpriority="high" src="/cram_school/youtube.png"></img>
                                    </Col>
                                </Row>
                                {/* <Row style={{ fontSize: '23px' }}>我想要暸解更多</Row> */}
                                {/* <Form autoComplete='off'>
                                <Row >
                                    <Col span={13}>
                                        <Form.Item
                                            // {...formItemLayout}
                                            name="contact"
                                            // label="請留下您的聯絡方式"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '',
                                                },
                                            ]}
                                        >
                                            <Input style={{ borderRadius: '0px' }} placeholder="請留下您的聯絡方式" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Button size="large" style={{ background: '#00A4E9', borderRadius: '0px' }} >
                                            <div style={{ color: '#ffffff' }}>
                                                與我聯絡
                                            </div>
                                        </Button>
                                    </Col>
                                </Row>
                            </Form> */}
                            </Col>
                            <Col span={24}>
                                {label_language.Button.children.change[language]}
                                <Button type='link'
                                    onClick={() => {
                                        localStorage.setItem('mobile', 'true')
                                        navigate(0)
                                    }}
                                >{label_language.Button.children.smartphone[language]}</Button>
                                <Button type='link'
                                    onClick={() => {
                                        localStorage.setItem('mobile', 'false')
                                        navigate(0)
                                    }}
                                >{label_language.Button.children.computer[language]}</Button>
                            </Col>
                        </Row>
                        {/* <Row justify="end">
                    <Col>
                        <Button type="primary">立即展開交流！</Button>
                    </Col>
                </Row> */}
                    </InputOutline>
                </Footer >
            </Layout >
        </>
    )
};
export default MainOutlet;